import { Carousel } from 'react-responsive-carousel'
import { makeStyles } from '@material-ui/core/styles'
import InvertedCommas from 'src/assets/InsuranceSpotlightImages/Common/InvertedCommas.svg'

const Scenarios = ({ scenarioData }) => {
  const classes = useStyles()

  return (
    <>
      <Carousel
        infiniteLoop={true}
        showArrows={true}
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        autoPlay={true}
        stopOnHover={true}
      >
        {scenarioData?.map((scenarioDataItem, index) => {
          return (
            <div
              id='carouselItem'
              className={classes.carouselItem}
              key={`scenario_${scenarioDataItem?.id}`}
            >
              <div className={classes.detailsContainer}>
                <div className={classes.storyDetailsContainer}>
                  <div className={classes.headingContainer}>
                    <div className={classes.indexNumber}>{index + 1}</div>
                    <div className={classes.titleContainer}>
                      <span className={classes.storyTitle}>
                        {scenarioDataItem?.storyTitle}
                      </span>
                      <span className={classes.storyHeading}>
                        {scenarioDataItem?.storyHeading}
                      </span>
                    </div>
                  </div>
                  <div className={classes.scenarioImage}>
                    <img src={scenarioDataItem?.image} alt='Scenario' />
                  </div>
                </div>
                <div className={classes.invertedCommas}>
                  <img src={InvertedCommas} alt='InvertedCommas' />
                </div>
                <div className={classes.scenarioDetailsContainer}>
                  <div className={classes.scenarioTitle}>
                    {scenarioDataItem?.scenario?.title}
                  </div>
                  <div className={classes.explanationContainer}>
                    <div className={classes.firstExplanation}>
                      {scenarioDataItem?.scenario?.firstExplanation}
                    </div>
                    <div className={classes.secondExplanation}>
                      {scenarioDataItem?.scenario?.secondExplanation}
                    </div>
                  </div>
                  <div className={classes.scenarioDetails}>
                    {scenarioDataItem?.scenario?.details}
                  </div>
                </div>
              </div>
              <div className={classes.lessonContainer}>
                <span className={classes.lessonText}>Lesson: </span>
                <span className={classes.lessonContent} id='lessonContent'>
                  {scenarioDataItem?.lesson}
                </span>
              </div>
            </div>
          )
        })}
      </Carousel>
    </>
  )
}

export default Scenarios

const useStyles = makeStyles({
  carouselItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px',
  },
  scenarioImage: {
    width: '100%',
    textAlign: 'center',
    margin: '10px 0px',
    padding: '10px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '14px',
  },
  detailsContainer: {
    display: 'flex',
    gap: '10px',
    width: '100%',
    padding: '30px',
    justifyContent: 'center',
  },
  storyDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '30px',
    width: '100%',
  },
  scenarioDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '30px',
  },
  headingContainer: {
    display: 'flex',
    gap: '10px',
    width: '100%',
    alignItems: 'center',
  },
  indexNumber: {
    fontSize: '50px',
    fontWeight: 'bold',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  storyTitle: {
    fontSize: '15px',
    textAlign: 'left',
  },
  storyHeading: {
    fontSize: '17px',
    fontWeight: 'bold',
    textAlign: 'left',
  },
  scenarioTitle: {
    fontSize: '17px',
    textAlign: 'left',
    width: '100%',
  },
  explanationContainer: {
    display: 'flex',
    width: '100%',
    margin: '5px 0px',
  },
  firstExplanation: {
    background: '#FFE3E3',
    fontSize: '12px',
    width: '100%',
    padding: '20px',
    textAlign: 'left',
  },
  secondExplanation: {
    background: '#F2F2F2',
    fontSize: '12px',
    width: '100%',
    padding: '15px',
    textAlign: 'left',
  },
  scenarioDetails: {
    fontSize: '17px',
    width: '100%',
    textAlign: 'left',
  },
  lessonContainer: {
    margin: '20px 50px',
    fontSize: '15px',
    border: '1px solid #F1C3C3',
    borderRadius: '10px',
    padding: '15px',
    width: '100%',
  },
  invertedCommas: {
    maxWidth: '30px',
    color: '#CACACA',
    width: '100%',
  },
  lessonText: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize: '15px',
  },
  lessonContent: {
    color: '#B84D59',
    fontSize: '15px',
  },
  '@media (max-width: 1224px)': {
    detailsContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '10px',
      alignItems: 'center',
    },
    invertedCommas: {
      maxWidth: '30px',
      height: '0px',
      width: '100%',
    },
  },
  '@media (max-width: 768px)': {
    indexNumber: {
      fontSize: '30px',
    },
    storyTitle: {
      fontSize: '12px',
    },
    storyHeading: {
      fontSize: '14px',
    },
    scenarioTitle: {
      fontSize: '12px',
    },
    explanationContainer: {
      fontSize: '12px',
    },
    firstExplanation: {
      fontSize: '12px',
    },
    secondExplanation: {
      fontSize: '12px',
    },
    scenarioDetails: {
      fontSize: '12px',
    },
    lessonContainer: {
      fontSize: '12px',
    },
    lessonText: {
      fontSize: '12px',
    },
    lessonContent: {
      fontSize: '12px',
    },
  },
  '@media (max-width: 480px)': {
    indexNumber: {
      fontSize: '20px',
    },
    storyTitle: {
      fontSize: '10px',
    },
    storyHeading: {
      fontSize: '12px',
    },
    scenarioTitle: {
      fontSize: '12px',
    },
    explanationContainer: {
      fontSize: '12px',
    },
    firstExplanation: {
      fontSize: '12px',
    },
    secondExplanation: {
      fontSize: '12px',
    },
    scenarioDetails: {
      fontSize: '10px',
    },
    lessonContainer: {
      fontSize: '10px',
    },
    lessonText: {
      fontSize: '10px',
    },
    lessonContent: {
      fontSize: '10px',
    },
  },
  '@media (min-width: 1750px)': {
    storyDetailsContainer: {
      width: '90%',
    },
    storyTitle: {
      fontSize: '20px',
    },
    storyHeading: {
      fontSize: '20px',
    },
    scenarioTitle: {
      fontSize: '20px',
    },
    explanationContainer: {
      fontSize: '20px',
    },
    firstExplanation: {
      fontSize: '19px',
    },
    secondExplanation: {
      fontSize: '19px',
    },
    scenarioDetails: {
      fontSize: '20px',
    },
    lessonContainer: {
      fontSize: '20px',
    },
    lessonText: {
      fontSize: '20px',
    },
    lessonContent: {
      fontSize: '20px',
    },
  },
})
